import { render } from "./Linkedin.vue?vue&type=template&id=681b6762&scoped=true"
const script = {}

import "./Linkedin.vue?vue&type=style&index=0&id=681b6762&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681b6762"]])

export default __exports__